/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_ErrorInputs */



/**
* | output |
* | --- |
* | "Error creating event template" |
*
* @param {Context_Menu_Event_Template_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_error = /** @type {((inputs?: Context_Menu_Event_Template_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la création du modèle d'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Erstellen der Ereignisvorlage")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la creazione del modello di evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при создании шаблона события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al crear la plantilla de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建事件模板时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント テンプレートの作成中にエラーが発生しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेम्प्लेट बनाने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao criar o modelo de evento")
	return /** @type {LocalizedString} */ ("Error creating event template")
});